<div class="banner-popup" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
  <button type="button" class="banner-close" aria-label="Close" (click)="close(BannerCloseReason.BUTTON)">
    <span aria-hidden="true">&times;</span>
  </button>

  <ngb-carousel #carousel *ngIf="slides.length > 0"
    [interval]="interval"
    [wrap]="true"
    [showNavigationArrows]="false"
    [showNavigationIndicators]="slides.length > 1"
    [pauseOnHover]="false"
    [pauseOnFocus]="false"
    (slide)="onSlide($event)">
    <ng-template ngbSlide *ngFor="let slide of slides; let i = index" [id]="slideIdPrefix + i">
      <img class="banner-image" [src]="slide.url" alt="" draggable="false" />
    </ng-template>
  </ngb-carousel>
</div>
